import { EnrichedPurchaseActivityTickets } from 'apollo/types';
import Table from 'components/UI/Table';
import React, { FC } from 'react';
import columns from './utils/columns';
import styles from '../OrderDetail.module.scss';
import dataToTable from './utils/dataToTable';

export interface ActivitiesTableProps {
  purchaseId: string;
  activityTickets: EnrichedPurchaseActivityTickets[] | undefined;
  visitDate: string | undefined;
}

const ActivitiesTable: FC<ActivitiesTableProps> = ({
  purchaseId,
  activityTickets,
  visitDate,
}: ActivitiesTableProps) => {
  const isTicketInfoAvailable = activityTickets && purchaseId !== undefined;

  return (
    <Table
      title={() => 'Actividades'}
      columns={columns}
      size="large"
      pagination={false}
      className={!isTicketInfoAvailable ? styles.Disabled : ''}
      dataSource={dataToTable(activityTickets || [], visitDate || '')}
    />
  );
};

export default ActivitiesTable;
